import base64ToBlob from '../base64ToBlobConverter/base64ToBlobConverter'

export const cropImage = ({ x: borderX, y: borderY, width: borderWidth, height: borderHeight, offsetPercent = 0 }, base64File) => {
  return new Promise(resolve => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const image = new Image()

    image.onload = () => {
      const offsetPx = borderWidth * offsetPercent / 100

      const getSizesWithOffset = (borderStart, borderSize, imageSize) => {
        const start = borderStart - offsetPx > 0 ? borderStart - offsetPx : 0
        const rightSize = (borderStart + borderSize + offsetPx) > imageSize ? imageSize - borderStart - borderSize : offsetPx
        const leftSize = borderStart - start
        const size = borderSize + rightSize + leftSize
        return { start, size }
      }

      const { start: x, size: width } = getSizesWithOffset(borderX, borderWidth, image.width)
      const { start: y, size: height } = getSizesWithOffset(borderY, borderHeight, image.height)

      canvas.width = width
      canvas.height = height
      ctx.drawImage(
        image,
        x,
        y,
        width, height,
        0, 0,
        width, height
      )
      resolve(canvas.toDataURL('image/png').replace(/^data:image\/[a-z]+;base64,/, ''))
    }
    image.src = URL.createObjectURL(base64ToBlob(base64File))
  })
}
